import { render, staticRenderFns } from "./AgreeTerms.vue?vue&type=template&id=3c9b45a8&scoped=true"
import script from "./AgreeTerms.vue?vue&type=script&lang=js"
export * from "./AgreeTerms.vue?vue&type=script&lang=js"
import style0 from "./AgreeTerms.vue?vue&type=style&index=0&id=3c9b45a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9b45a8",
  null
  
)

export default component.exports